import React from 'react';
import { Helmet } from 'react-helmet-async';
import DashboardTopbar from '../components/DashboardTopbar';
import PlansContent from '../components/PlansContent';
import './PlansPage.css';

function Plans() {
  return (
    <div className="App dashboard-page plans-page">
      <Helmet>
        <title>Planos - Preparate</title>
        <meta name="description" content="Conheça os planos da Preparate e escolha o melhor para sua preparação para concursos." />
        <link rel="canonical" href="https://user.preparatequestoes.com.br/planos" />
      </Helmet>
      <DashboardTopbar label="Planos" />

      <div className="plans-container">
        <PlansContent />
      </div>
    </div>
  );
}

export default Plans;
